import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { belongsTo } from 'ember-data/relationships';
import EnvironmentModel from 'cio/models/environment';
import { modelApiAction } from 'cio/utils/model-api-actions';

export default class SigningSecretModel extends Model {
  @attr('string') secret!: string;
  @belongsTo('environment', { async: false, inverse: null }) environment!: EnvironmentModel;

  regenerateSigningKey = modelApiAction({
    type: 'PUT',
    path: '',
    after(this: SigningSecretModel, response) {
      this.store.pushPayload(response);
    },
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'signing-secret': SigningSecretModel;
  }
}
